export const getTenantFromHostname = (): string | undefined => {
  // const env = import.meta.env.VITE_ENV_NAME;

  const hostNameArr = location.hostname?.split(".");

  if (hostNameArr?.[0] === "admin") {
    return hostNameArr?.[0] === "admin" ? undefined : hostNameArr?.[0];
  }

  const isAdminUrl = (hostNameArr?.[1] || hostNameArr[2]) === "admin";

  if (isAdminUrl) return undefined;

  return hostNameArr?.[0] ?? undefined;
};
